import { render } from "./SalonRegistration.vue?vue&type=template&id=71aff87d&scoped=true"
import script from "./SalonRegistration.vue?vue&type=script&lang=js"
export * from "./SalonRegistration.vue?vue&type=script&lang=js"

import "./SalonRegistration.vue?vue&type=style&index=0&id=71aff87d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71aff87d"]])

export default __exports__